module.exports = __webpack_public_path__ + "static/pca-product-c7147638f0037d38b867e17bdf868fd1.png";